export const API_BASE = '/api';
export const TOKEN_KEY = 'ad_bi_token';
export const GLOBAL_FILTERS_KEY = 'ad_bi_global_filters';
export const LOCALE_KEY = 'ad_bi_locale';
export const SALES_DATASET_MODE_KEY = 'ad_bi_sales_dataset_mode';

export const ADMIN_ROLE_OPTIONS: Array<{ value: string; label: string }> = [
    { value: 'user', label: 'Korisnik' },
    { value: 'manager', label: 'Manager' },
    { value: 'administrator', label: 'Administrator' },
    { value: 'superadministrator', label: 'Superadministrator' },
];
